import request from '@/modules/huyu-framework/backend/utils/request';

// 画像管理分页列表（username 模糊 + 活跃/价值/生命周期筛选）
export function getProfilePage(params) {
  return request({
    url: '/ai/memory/profile/page',
    method: 'get',
    params: params
  });
}

// 画像管理概览统计
export function getProfileOverview() {
  return request({
    url: '/ai/memory/profile/overview',
    method: 'get'
  });
}

// 手动触发画像 ETL（异步执行，接口立即返回，后台完成需稍后刷新查看）
export function runProfileEtl() {
  return request({
    url: '/ai/memory/profile/etl/run',
    method: 'post'
  });
}

// 触发会话记忆抽取（前端关闭/切换/删除会话时调用，异步触发不阻塞）
export function flushChatMemory(chatId) {
  return request({
    url: '/ai/memory/flush',
    method: 'post',
    data: { chatId }
  });
}

// 查询用户画像（完整实体，含槽位/兴趣标签/行为统计）
export function getProfile(username) {
  return request({
    url: '/ai/memory/profile',
    method: 'get',
    params: { username }
  });
}

// 查询用户标签列表
export function getTags(username) {
  return request({
    url: '/ai/memory/tags',
    method: 'get',
    params: { username }
  });
}

// 查询用户记忆列表
export function getMemories(username) {
  return request({
    url: '/ai/memory/list',
    method: 'get',
    params: { username }
  });
}

// 级联删除某用户全部画像与记忆（隐私删除）
export function deleteUserMemory(username) {
  return request({
    url: '/ai/memory/user/' + encodeURIComponent(username),
    method: 'delete'
  });
}

// 删除单条记忆（含向量级联）
export function deleteMemory(memoryUid) {
  return request({
    url: '/ai/memory/item/' + encodeURIComponent(memoryUid),
    method: 'delete'
  });
}
